import { createGlobalStyle } from "styled-components";

// SDS modals portal to document.body, so focus styles cannot be scoped via
// the FileManagerWrapper styled component the page reuses. This global block
// targets the wrapClassName we set on the SDS assign-user / set-expiry
// modals to suppress the project-wide yellow focus glow inherited from
// globalStyle.js. Kept separate from the file-manager equivalent so SDS can
// adjust focus colours independently.
export const SDSModalGlobalStyles = createGlobalStyle`
  .sds-bulk-modal {
    .ant-input:focus,
    .ant-input-focused,
    .ant-input-affix-wrapper-focused,
    .ant-select-focused .ant-select-selector,
    .ant-select-selector:focus,
    .ant-picker:hover,
    .ant-picker-focused {
      box-shadow: 0 0 0 2px rgba(11, 42, 27, 0.15) !important;
      border-color: #0b2a1b !important;
    }
  }
`;
